import React from 'react';
import { createPortal } from 'react-dom';
import { LoadingSpinner } from '../LoadingSpinner';

/**
 * full viewport loading spinner
 * @constructor
 */
export const FullPageLoadingSpinner: React.FunctionComponent = () =>
  createPortal(
    <div className="fixed inset-0 z-1000">
      <LoadingSpinner />
    </div>,
    document.body
  );
